module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-05.c38d491b.svg";